// extracted by mini-css-extract-plugin
export default {"root":"LoginForm_root__RwhyT marketplaceModalFormRootStyles","forgotPassword":"LoginForm_forgotPassword__tByAG","recoveryLink":"LoginForm_recoveryLink__iyezw"};